import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PATHS } from '../../../../shared/paths';
import { DiseaseTrimmed } from 'shared/types';

@Injectable({
    providedIn: 'root',
})
export class EspanolService {
    spanishPath = PATHS.diseasePageEspanol;
    diseasePageId = PATHS.diseasePageId;
    diseasePageName = PATHS.diseasePageName;

    constructor(private http: HttpClient) {}

    getSpanishPage(spanishPageURL: string) {
        const compiledURL = PATHS.diseasePageEspanolSource + spanishPageURL;
        return this.http.get(compiledURL, { responseType: 'text' });
    }

    getLinkToEnglish(parsedHTML: Document): string | boolean {
        const link = Array.from(parsedHTML.querySelectorAll('#diseaseIntroPage a')).find(anchor => anchor.textContent?.trim().toLowerCase() === 'information in english');
        return link?.getAttribute('href') || false;
    }

    getLinkToSpanish(disease: Pick<DiseaseTrimmed, 'spanishId' | 'spanishName'>): string | boolean {
        if (!disease?.spanishId || !disease?.spanishName) {
            return false;
        }

        return this.paramsToLinkSpanish(disease.spanishId, disease.spanishName);
    }

    private paramsToLinkSpanish(diseaseID: number, diseaseName: string): string {
        return '/' + this.spanishPath.replace(this.diseasePageId, diseaseID.toString(10)).replace(this.diseasePageName, diseaseName);
    }
}
